
/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Identicar si los giros tienen items hijos"
 *
 * AUTOR:     GAMORALES
 * FECHA:     04/Feb/2020
 *
*/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroItems'
})
export class FiltroItemsPipe implements PipeTransform {

  transform(value: any[], filter: boolean): any {
    var items;
    if (filter){
      items = value.filter((val) => {
        return val.ITEMS.length > 0;
      });
    } else {
      items = value.filter((val) => {
        return val.ITEMS.length == 0;
      });
    }
    return items;
  }

}
